import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditAgent from './AddEditAgent';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
           
            { id: 'id', label: 'Agent Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'role', label: 'Role' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
        ])

        setHeadMobileCells([
            { id: 'id', label: 'Agent Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'Agent Id' },
            { id: 'phone', label: 'Phone' },
            { id: 'email', label: 'Email' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'Agent Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'role', label: 'Role' },
            { id: 'created', label: 'Registered' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'document', label: 'Document verification' },
        ])

        setEditCells([
            { id: 'id', label: 'Agent Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'address', label: 'Address' },
        ])

        setAddCells([
            { id: 'id', label: 'Agent Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'status_users', label: 'Status' },
            { id: 'address', label: 'Address' },
        ])

        setAddCellsName({ 
            id: '',
            store_address: '',
            first_name: '',
            last_name: '',
            point_users: '',
            total_ordered_products: '',
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            email: '',
            phone: '',
            status_users: '',
            role: '',
            user_redeem_time: ''
         })
    
        setSearchValue("phone")
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditAgent}
            control={true}
            orderBy="created" 
            data="agent" 
            addItemButton={false}
            addItemText="Add Agent"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="agent_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  